import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-team-member2',
  templateUrl: './team-member2.component.html',
  styleUrls: ['./team-member2.component.scss']
})
export class TeamMember2Component implements OnInit {

  constructor(private titleService: Title) { }

  ngOnInit(): void {
    this.titleService.setTitle('MISK - Eng. Mohamed Zuhair Wanli');
  }
}
